import { Injectable } from '@angular/core';
import { ECampaignStatus } from '@enums/campaign.enum';
import { TCampaignApi, TCampaignCopyPayload } from '../campaigns.interface';

@Injectable({
  providedIn: 'root',
})
export class CreateCampaignDialogCopyPayloadService {
  public sanitize(sourceCampaign: TCampaignApi): TCampaignCopyPayload {
    let sanitizedCampaign = this.removeIdFieldsRecursively(sourceCampaign) as TCampaignCopyPayload;
    sanitizedCampaign = this.removeCampaignExports(sanitizedCampaign);
    sanitizedCampaign = this.setCampaignStatus(sanitizedCampaign);

    return sanitizedCampaign;
  }

  private removeIdFieldsRecursively(value: unknown, path: string[] = []): unknown {
    if (Array.isArray(value)) {
      return value.map((item) => this.removeIdFieldsRecursively(item, path));
    }

    if (!value || typeof value !== 'object') {
      return value;
    }

    const sourceObject = value as Record<string, unknown>;
    const sanitizedObject: Record<string, unknown> = {};

    for (const [key, nestedValue] of Object.entries(sourceObject)) {
      if (this.isRemovableIdField(key, path)) {
        continue;
      }

      sanitizedObject[key] = this.removeIdFieldsRecursively(nestedValue, [...path, key]);
    }

    return sanitizedObject;
  }

  private isRemovableIdField(key: string, path: string[]): boolean {
    if (!this.isIdField(key)) {
      return false;
    }

    const unremovableIdFields = ['creatorId', 'customerId', 'gameId', 'iconId', 'imageId', 'fileId'];

    if (unremovableIdFields.includes(key)) {
      return false;
    }

    if (this.isWithinCampaignCreatorBranch(path)) {
      return false;
    }

    if (this.isWithinCustomerBranch(path)) {
      return false;
    }

    return true;
  }

  private isIdField(key: string): boolean {
    const normalizedKey = key.toLowerCase();

    return normalizedKey.endsWith('id');
  }

  private isWithinCampaignCreatorBranch(path: string[]): boolean {
    const campaignCreatorsIndex = path.indexOf('campaignCreators');
    const creatorIndex = path.indexOf('creator');

    return campaignCreatorsIndex !== -1 && creatorIndex > campaignCreatorsIndex;
  }

  private isWithinCustomerBranch(path: string[]): boolean {
    return path.includes('customer');
  }

  private removeCampaignExports(campaign: TCampaignCopyPayload): TCampaignCopyPayload {
    return {
      ...campaign,
      campaignExports: undefined,
      creatorCampaignExportId: undefined,
      creatorCampaignExports: undefined,
    };
  }

  private setCampaignStatus(campaign: TCampaignCopyPayload): TCampaignCopyPayload {
    return {
      ...campaign,
      status: ECampaignStatus.draft,
    };
  }
}
